<template>
    <v-avatar v-if="$auth.loggedIn" class="border--bronze" :size="size">
        <img :src="user.avtarName" alt="profile picture" />
    </v-avatar>
</template>

<script>
export default {
    props: {
        size: { type: String, default: "62", required: true }
    },
    // data() {
    //   return {
    //     noImage: require('@/assets/images/noImage.png')
    //   }
    // },
    computed: {
        user() {
            return this.$store.state.profile.data
        }
    }
}
</script>
